import React, { useMemo } from 'react';
import { Box, Grid, Paper } from '@material-ui/core';
// import { useStore } from '@tanstack/react-form'; // KALDIRILDI
import { SignatureCard } from './SignatureCard';
import { FileManager } from './FileManager';
import { generateRandomId } from '../../utils/file';

function useFormValues(form, selector) {
  const [val, setVal] = React.useState(() => selector(form.values));
  React.useEffect(() => {
    const unsub = form.subscribe(() => setVal(selector(form.values)));
    return unsub;
  }, [form, selector]);
  return val;
}

export function Attachments({ form }) {
    const { Files, FileTypes } = useFormValues(form, v => ({
      Files: v.Files || [],
      FileTypes: v.FileTypes || []
    }));

    const { attachments, signatures } = useMemo(() => {
        return Files.reduce(
            (acc, file) => {
                file.id = file.id || generateRandomId();
                if (file.FileName === 'Technician Signature') {
                    acc.signatures.TechnicianSignature = file;
                } else if (file.FileName === 'Customer Signature') {
                    acc.signatures.CustomerSignature = file;
                } else {
                    acc.attachments.push(file);
                }
                return acc;
            },
            { attachments: [], signatures: {} }
        );
    }, [Files]);

    return (
        <Paper>
            <Box px={2} py={2} mb={1}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FileManager
                            files={attachments}
                            fileTypes={FileTypes}
                            onFileUpload={file => {
                                const newFile = {
                                    id: generateRandomId(),
                                    Type: FileTypes[0]?.Id || 1,
                                    FileName: file.name,
                                    FileData: file.data,
                                    FileType: file.type
                                };
                                form.setFieldValue('Files', [...Files, newFile]);
                            }}
                            onFileChange={file => {
                                form.setFieldValue(
                                    'Files',
                                    Files.map(f => (f.id === file.id ? file : f))
                                );
                            }}
                            onFileDelete={file => {
                                form.setFieldValue(
                                    'Files',
                                    Files.filter(f => f.id !== file.id)
                                );
                            }}
                        />
                    </Grid>
                    <Grid container item spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <SignatureCard
                                title="Technician Signature"
                                fileName="Technician_Signature"
                                alreadyExists={!!signatures.TechnicianSignature?.Id}
                                signatureData={signatures.TechnicianSignature?.FileData}
                                onSignatureSave={image => {
                                    form.setFieldValue('Files', [
                                        ...Files,
                                        {
                                            id: generateRandomId(),
                                            Type: 1,
                                            FileName: 'Technician Signature',
                                            FileData: image.data,
                                            FileType: image.outputFormat
                                        }
                                    ]);
                                }}
                                onSignatureDelete={() => {
                                    form.setFieldValue(
                                        'Files',
                                        Files.filter(f => f.FileName !== 'Technician Signature')
                                    );
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <SignatureCard
                                title="Customer Signature"
                                fileName="Customer_Signature"
                                alreadyExists={!!signatures.CustomerSignature?.Id}
                                signatureData={signatures.CustomerSignature?.FileData}
                                onSignatureSave={image => {
                                    form.setFieldValue('Files', [
                                        ...Files,
                                        {
                                            id: generateRandomId(),
                                            Type: 1,
                                            FileName: 'Customer Signature',
                                            FileData: image.data,
                                            FileType: image.outputFormat
                                        }
                                    ]);
                                }}
                                onSignatureDelete={() => {
                                    form.setFieldValue(
                                        'Files',
                                        Files.filter(f => f.FileName !== 'Customer Signature')
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}
